import styled from "styled-components";

import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../constants/Styles";

const Title = styled.div<{ smallTitle?: boolean }>`
  font-size: ${({ smallTitle }) =>
    smallTitle ? FONT_SIZE.size24 : FONT_SIZE.size64};
  margin-bottom: 2.5rem;
`;

const Description = styled.div`
  font-size: ${FONT_SIZE.size18};
  color: ${COLORS.secondaryLight};
  font-weight: ${FONT_WEIGHT.weight400};
  margin-bottom: 1rem;

  > a {
    color: ${COLORS.linkBlue};
    font-weight: ${FONT_WEIGHT.weight500};
  }
`;

export { Title, Description };
